// ─────────────────────────────────────────────────────────────
// RK REAL ESTATE — CENTRAL EDITABLE CONFIG
// Contact details, categories, locations and page content.
// Properties and Projects are managed from the Admin Panel (/admin).
// ─────────────────────────────────────────────────────────────

export const CONTACT = {
  brand: "RK Real Estate",
  positioning: "Buy • Sell • Rent",
  phoneDisplay: "+91 86858 77967",
  phoneHref: "tel:+918685877967",
  phone2Display: "+91 98297 10557",
  phone2Href: "tel:+919829710557",
  whatsappNumber: "919829710557",
  email: "hello@rkrealestate.com",
  address: "SF-02, Capital Arcadia, Alwar Bypass Road, Bhiwadi – 301019",
  socials: { instagram: "#", facebook: "#", youtube: "#" },
};

export const DEFAULT_WA_MESSAGE =
  "Hi RK Real Estate, I'm looking for a property. Please help me with suitable options.";

export const waLink = (msg = DEFAULT_WA_MESSAGE, number = CONTACT.whatsappNumber) =>
  `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Properties", href: "#properties" },
  { label: "Buy", href: "#buy" },
  { label: "Rent", href: "#rent" },
  { label: "Sell", href: "#sell" },
  { label: "Projects", href: "#projects" },
  { label: "About Us", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGhvdXNlJTIwZXh0ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxMjc2OTg1fDA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1714974528757-f63c72154a1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjByZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBhZHZpc29yJTIwYWR2aXNvciUyMGNsaWVudCUyMG1lZXRpbmd8ZW58MHx8fHwxNzkxMjc2OTkyfDA&ixlib=rb-4.1.0&q=85",
  investment: "https://images.unsplash.com/photo-1690357737706-b421b193048a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwbW9kZXJuJTIwZ2xhc3MlMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc5MTI3Njk4NXww&ixlib=rb-4.1.0&q=85",
};

export const BUDGET_OPTIONS = [
  { value: "under-50", label: "Under ₹50 Lakh" },
  { value: "50-100", label: "₹50 Lakh – ₹1 Cr" },
  { value: "100-300", label: "₹1 Cr – ₹3 Cr" },
  { value: "300-plus", label: "₹3 Cr+" },
];

export const PROPERTY_TYPES = ["Residential", "Commercial", "Plot"];

export const CATEGORIES = [
  {
    id: "residential",
    title: "Residential",
    desc: "Homes designed around your lifestyle.",
    tags: "Apartments • Flats • Villas • Houses",
    cta: "Explore Residential",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGhvdXNlJTIwZXh0ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxMjc2OTg1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "commercial",
    title: "Commercial",
    desc: "Spaces built for business and growth.",
    tags: "Shops • Offices • Commercial Spaces",
    cta: "Explore Commercial",
    image: "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwbW9kZXJuJTIwZ2xhc3MlMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc5MTI3Njk4NXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "plots",
    title: "Plots",
    desc: "Choose the space for your next plan.",
    tags: "Residential • Commercial • Investment",
    cta: "Explore Plots",
    image: "https://images.unsplash.com/photo-1717446585456-15dcbb9f039c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxncmVlbiUyMGxhbmQlMjBwbG90JTIwcmVhbCUyMGVzdGF0ZSUyMG5hdHVyZSUyMG1lYWRvd3xlbnwwfHx8fDE3OTEyNzY5OTJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "rental",
    title: "Rental",
    desc: "Find a place that works for you.",
    tags: "Homes • Flats • Commercial",
    cta: "Explore Rentals",
    image: "https://images.unsplash.com/photo-1648881806148-e5c51179c826?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb20lMjBkZXNpZ258ZW58MHx8fHwxNzkxMjc2OTg1fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const WHY_US = [
  { num: "01", title: "Local Market Understanding", desc: "Relevant property guidance based on the local market." },
  { num: "02", title: "Buy • Sell • Rent", desc: "One place for your different real estate requirements." },
  { num: "03", title: "Personalized Assistance", desc: "Property suggestions based on your individual needs." },
  { num: "04", title: "Site Visit Support", desc: "Easy coordination when you're ready to see a property." },
  { num: "05", title: "Clear Communication", desc: "Straightforward information throughout your property journey." },
  { num: "06", title: "Customer-Focused Approach", desc: "We focus on understanding your requirement before suggesting properties." },
];

// Operating localities — edit names/tags/images here.
export const LOCATIONS = [
  {
    name: "Downtown Prime",
    tag: "Luxury Living & Hub",
    image: "https://images.unsplash.com/photo-1625331961398-26edb1e237ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjaXR5JTIwc2t5bGluZSUyMGFlcmlhbCUyMHZpZXclMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbmVpZ2hib3Job29kfGVufDB8fHx8MTc5MTI3Njk5Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Green Valley Springs",
    tag: "Peaceful Gated Villas",
    image: "https://images.unsplash.com/photo-1570658379397-89d15db1b0de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjaXR5JTIwc2t5bGluZSUyMGFlcmlhbCUyMHZpZXclMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbmVpZ2hib3Job29kfGVufDB8fHx8MTc5MTI3Njk5Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Tech Corridor West",
    tag: "Commercial & IT Parks",
    image: "https://images.unsplash.com/photo-1531379972711-3c48ecf21e04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjaXR5JTIwc2t5bGluZSUyMGFlcmlhbCUyMHZpZXclMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbmVpZ2hib3Job29kfGVufDB8fHx8MTc5MTI3Njk5Mnww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Waterfront Avenue",
    tag: "High-Rise Apartments",
    image: "https://images.unsplash.com/photo-1680146630012-80b69aaee4c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjaXR5JTIwc2t5bGluZSUyMGFlcmlhbCUyMHZpZXclMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbmVpZ2hib3Job29kfGVufDB8fHx8MTc5MTI3Njk5Mnww&ixlib=rb-4.1.0&q=85",
  },
];

export const STEPS = [
  { num: "01", title: "Tell Us Your Requirement", desc: "Share what you're looking for." },
  { num: "02", title: "Explore Suitable Properties", desc: "Browse properties matching your needs." },
  { num: "03", title: "Schedule a Site Visit", desc: "See the property and understand the space." },
  { num: "04", title: "Make Your Decision", desc: "Move forward when you find the right fit." },
];

// Genuine client reviews replace these placeholders when provided.
export const TESTIMONIALS = [
  { id: "t-1", text: "Add genuine customer review here." },
  { id: "t-2", text: "Add genuine customer review here." },
  { id: "t-3", text: "Add genuine customer review here." },
];
